import { useCreateContact } from "@api/contactService";
import ContactEdit from "./ContactEdit";

export default function ContactCreate() {
    return <ContactEdit
        mutation={useCreateContact}
        title={'New Contact'}
        create
    />
}
